import {BaseWidget} from "./BaseWidget";
import * as Formats from "../constants/Formats";

import moment from 'moment'

export class TimeFieldWidget extends BaseWidget {
    afterAttach() {
        super.afterAttach();
        let that = this;
        that.timePicker = that.findElement().kendoTimePicker({
            change: (e) => that.onEdit(that.readValueFromElement()),
        }).data("kendoTimePicker");
        that.findElement().on("focus",(e)=>{this.timePicker.open()})
    }

    setValueInElement(value) {
        this.timePicker.value(addTimeZoneOffsetToDate(value));
    }

    readValueFromElement() {
        let val = this.timePicker.value();
        if (!val)
            return null;
        let format = prepareTimeVal(val);
        return format;
    }

    setEnabled(enabled) {
        this.timePicker.enable(enabled);
    }
}

export function prepareTimeVal(val){
    val = subtractTimeZoneOffsetToDate(val);
    let day = 1;
    let hrs = val.getHours();
    if (hrs == 0 || hrs == 1)
        day++;
    val.setFullYear(1970, 0, day);
    let date = new moment(val, Formats.DATE_MOMENT_SERVER_FORMAT);
    return date.format(Formats.DATE_MOMENT_SERVER_FORMAT);
}

export function subtractTimeZoneOffsetToDate(value) {
    if (!value)
        return "";
    let date = kendo.parseDate(value, Formats.DATE_SERVER_FORMAT);
    return new Date(date.getTime() - (date.getTimezoneOffset() * 60 * 1000));
}

export function addTimeZoneOffsetToDate(value) {
    if (!value)
        return "";
    let date = kendo.parseDate(value, Formats.DATE_SERVER_FORMAT);
    return kendo.toString(new Date(date.getTime() + (date.getTimezoneOffset() * 60 * 1000)), 't');
}